import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
} from '@material-ui/core';
import React, { FC } from 'react';

interface Props {
  name: string;
  open?: boolean;
  onDelete?: () => void;
  onClose?: () => void;
}

const DeleteConfirmation: FC<Props> = ({ name, open = false, onDelete, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete "{name}"</DialogTitle>
      <DialogContent>Are you sure you would like to delete the lesson "{name}"?</DialogContent>
      <DialogActions>
        <Button onClick={onClose} autoFocus>
          Cancel
        </Button>
        <DeleteButton variant="contained" onClick={onDelete}>
          Delete
        </DeleteButton>
      </DialogActions>
    </Dialog>
  );
};

// Styled components
const DeleteButton = styled(Button)(({ theme }) => ({
  color: '#ffffff',
  backgroundColor: theme.palette.error.main,

  '&:hover': {
    backgroundColor: theme.palette.error.dark,
  },
}));

export default DeleteConfirmation;
